'use strict';

import GeoLocation from '../../geo/geoLocation';
import Room from './room';
import Building from './building';
import LandPlot from './landPlot';
import Infrastructure from './infrastructure';

/**
 * Объект недвижимости
 * @constructor
 */
function Property (object, dictionary) {
  this.id = object.get('id');

  this.geoLocation = new GeoLocation(object);

  this.room = new Room(object, dictionary);

  this.building = new Building(object, dictionary);

  this.landPlot = new LandPlot(object, dictionary);

  this.infrastructure = new Infrastructure(object, dictionary);

  this.type = dictionary.getObjectType(object.get('objectTypeId'));

  this.cases = dictionary.getObjectCase(object.get('objectTypeId'));
}

/**
 * Id объекта недвижимости
 * @returns {*}
 */
Property.prototype.getId = function () {
  return this.id;
};

/**
 * Тип недвижимости
 * @returns { Immutable.Map }
 */
Property.prototype.getType = function () {
  return this.type;
};

/**
 * Склонения для тип недвижимости
 * @returns { Immutable.Map }
 */
Property.prototype.getTypeCase = function () {
  return this.cases;
};

/**
 * Помещение
 * @returns {Room}
 */
Property.prototype.getRoom = function () {
  return this.room;
};

/**
 * Инфраструктура
 * @returns {Infrastructure}
 */
Property.prototype.getInfrastructure = function () {
  return this.infrastructure;
};

/**
 * Здание
 * @returns {Building}
 */
Property.prototype.getBuilding = function () {
  return this.building;
};

/**
 * Участок
 * @returns {LandPlot}
 */
Property.prototype.getLandPlot = function () {
  return this.landPlot;
};

/**
 * Местоположение объекта
 * @returns { GeoLocation }
 */
Property.prototype.getGeoLocation = function () {
  return this.geoLocation;
};

export default Property;



// WEBPACK FOOTER //
// ./src/classes/announcement/property/property.js